var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMealTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.5039V11.5039C13.9977 10.0003 13.4314 8.5522 12.413 7.44593C11.3947 6.33966 9.99831 5.65571 8.5 5.52926V4.50391H10V3.50391H6V4.50391H7.5V5.52926C6.00169 5.65571 4.60533 6.33966 3.58695 7.44593C2.56857 8.5522 2.00227 10.0003 2 11.5039V12.5039H1V13.5039H15V12.5039H14ZM8 6.50391C9.1521 6.50542 10.2685 6.9041 11.1609 7.63273C12.0533 8.36136 12.6672 9.3754 12.8992 10.5039H3.10075C3.33269 9.37538 3.94663 8.36133 4.83907 7.63269C5.73151 6.90406 6.84789 6.50539 8 6.50391ZM3 11.5039H13V12.5039H3V11.5039Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMealTime);
export default __webpack_public_path__ + "static/media/ic-meal-time.aa201bae00fa2e8ce81fe36afe6a33a9.svg";
export { ForwardRef as ReactComponent };